module.exports = __webpack_public_path__ + "static/media/4.c0c006c7.jpg";